/** @format */

import React, { useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { fileUpload } from "../../utils/utils";
import { FileUpload } from "primereact/fileupload";
import useSaveWeather from "./hooks/useSaveWeather";
import { Messages } from "primereact/messages";
import ThreeDotsLoader from "../common/ThreeDotsLoader";
import { isWeatherEmpty } from "./utils/utils";
import { BUSINESS_UNIT } from "../../utils/PreviousSession.constants";
import { REGIONS } from "./constants/constants";
// import moment from "moment";
// import service from "../../utils/service";

function Weather(props) {
  const [editContent, setEditContent] = useState(false);
  const [temp, setTemp] = useState("");
  const [uploadPercent, setUploadPercent] = useState(0);
  const [isSectionInValid, setIsSectionInValid] = useState(false);
  const mutation = useSaveWeather();
  const msgRef = useRef();
  const selectedIndex = useRef(-1);
  const loading = props.loading;
  function handleEdit(section) {
    setTemp(section.content);
    setEditContent(true);
    props.setEditing("weather", true, false);
  }

  function handleCancel() {
    setEditContent(false);
  }

  function handleSave(section) {
    section.content = temp;
    setEditContent(false);

    props.getSectionData(section);
  }

  const headerImgSrc =
    props.businessUnit === BUSINESS_UNIT.COCOA
      ? "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/cocoa_weather.png"
      : "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/WeatherHeader.png";

  const uploadProgressHandler = (total, loaded) => {
    const percent = Math.round((100 * loaded) / total);
    setUploadPercent(percent);
  };

  const handleImageUpload = (e, ind) => {
    selectedIndex.current = ind;
    setUploadPercent(1);
    fileUpload(e.files[0], section, uploadProgressHandler)
      .then((imagePath) => {
        props.updateImagePath(section, imagePath, ind);
      })
      .catch((err) => {
        setUploadPercent(0);
        selectedIndex.current = -1;
      });
    props.setEditing("weather", true, false);
  };

  function renderEditContent(publish, diff_date) {
    let returnObj =
      publish === true || diff_date < 0 ? null : (
        <tr className='editContent'>
          <td>
            <span
              style={{ fontSize: "16px", color: "grey" }}
              onClick={() => {
                handleEdit(section);
              }}
            >
              Edit Content
            </span>
          </td>
        </tr>
      );
    return returnObj;
  }

  function renderContent(editContent) {
    let returnObj = (
      <div>
        <div
          style={{
            fontSize: "14px",
            // color: "#cccccc",
            margin: "8px",
            whiteSpace: "pre-line",
            textAlign: "justify",
            wordBreak: "break-word",
          }}
        >
          {section.content}
        </div>
      </div>
    );
    return returnObj;
  }
  let section = props.section;
  function handleSectionSave() {
    if (isWeatherEmpty(props.region, section)) {
      setIsSectionInValid(true);
    } else {
      mutation.mutate(
        {
          ...props.section,
          reportDate: props.reportDate,
          regionId: props.regionId,
          productLineId: props.productLineId,
        },
        {
          onSuccess: (data) => {
            if (msgRef.current) {
              msgRef.current.clear();
              msgRef.current.show([
                {
                  sticky: false,
                  severity: "success",
                  summary: "Success",
                  detail: "Weather saved successfully",
                  closable: false,
                  life: 2000,
                },
              ]);
            }
            props.setEditing("weather", false, false);
            props.updateSectionId("weather", data.data);
            mutation.reset();
          },
          onError: () => {
            if (msgRef.current) {
              msgRef.current.clear();
              msgRef.current.show([
                { sticky: true, severity: "error", summary: "Error", detail: "Error saving Weather", closable: true },
              ]);
            }
            props.setEditing("weather", true, false);
            mutation.reset();
          },
        }
      );
    }
  }
  let weatherImages = [];
  if ("precipitationImage" in section && "temperatureImage" in section) {
    weatherImages = [[section.precipitationImage, section.temperatureImage]];
  }
  if ("image1" in section) {
    weatherImages = [
      [section.image1, section.image2],
      [section.image3, section.image4],
    ];
  }
  return (
    <div className='relative syndication__section__wrapper'>
      <table
        align='center'
        style={{
          width: "800px",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
        }}
      >
        <tbody>
          <tr>
            <td>
              <img
                src={decodeURIComponent(encodeURIComponent(props?.section?.headerImagePath || headerImgSrc))}
                alt='Weather header'
                width='800'
                height='50'
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>
      {(loading || mutation.isLoading) && (
        <div className='wtg__loader absolute'>
          <ThreeDotsLoader className='absolute' />
        </div>
      )}
      <table width='800' align='center' className='msg__container'>
        <Messages
          className='msg__content'
          ref={msgRef}
          onRemove={() => {
            console.log("REMOVED");
          }}
        />
      </table>
      <table
        align='center'
        style={{
          width: "800px",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
          marginBottom: "10px",
        }}
      >
        <tbody>
          <tr>
            <td valign='top'>
              {renderEditContent(props.publish, props.diff_date)}
              {renderContent(editContent)}
            </td>
          </tr>
        </tbody>
      </table>

      <table
        align='center'
        style={{
          width: "800px",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
          marginBottom: "10px",
        }}
      >
        <tbody>
          {weatherImages.map((images, __index) => {
            return (
              <tr align='right' key={__index}>
                {images.map((img, index) => {
                  let imgIndex;
                  if (__index === 0) {
                    imgIndex = index + 1;
                  } else {
                    let ind = __index;
                    let len = 0;
                    while (ind > 0) {
                      len += weatherImages[ind--].length;
                    }
                    imgIndex = len + index + 1;
                  }
                  return img !== null && img !== "" ? (
                    <td valign='middle' style={{ width: "50%" }} key={`${__index}__${index}__img`}>
                      <div>
                        <img
                          width={350}
                          height={250}
                          alt='TBD'
                          style={{
                            backgroundColor: "white",
                            border: "1px solid #DDD",
                            padding: "5px",
                          }}
                          src={decodeURIComponent(encodeURIComponent(img))}
                          onLoad={() => {
                            selectedIndex.current = -1;
                            setUploadPercent(0);
                          }}
                        />
                        {props.publish === false && props.diff_date >= 0 && (
                          <button
                            className='RemoveImage p-button p-button-sm diag-save-button floatRight'
                            style={{
                              borderRadius: "35px",
                              marginTop: "18px",
                              textAlign: "center",
                              padding: "10px",
                              color: "#FFFFFF",
                              boxSizing: "border-box",
                              backgroundColor: "#199B8B",
                            }}
                            onClick={() => {
                              props.updateImagePath(section, "", imgIndex);
                              props.setEditing("weather", true, false);
                              selectedIndex.current = -1;
                            }}
                          >
                            Remove image
                          </button>
                        )}
                      </div>
                    </td>
                  ) : (
                    <td align='center' key={`${__index}__${index}__img`}>
                      <FileUpload
                        className='fileUpload mr-3 mx-0 p-button-sm floatLeft generateImage'
                        customUpload
                        uploadHandler={(e) => handleImageUpload(e, imgIndex)}
                        chooseLabel='Choose File'
                        mode='basic'
                        auto
                        pt={{
                          chooseIcon: "hidden",
                        }}
                        disabled={imgIndex === selectedIndex.current && ![0, 100].includes(uploadPercent)}
                      />
                    </td>
                  );
                })}
              </tr>
            );
          })}
          {props.publish === true || props.diff_date < 0 ? null : (
            <Button
              pt={{ label: { className: "mx-0" } }}
              className='p-button p-button-sm diag-save-button savesectionbtn'
              label='Save Section Content & Image'
              onClick={() => handleSectionSave()}
            />
          )}
        </tbody>
      </table>
      <Dialog
        baseZIndex={10001}
        className='diag1'
        visible={editContent}
        style={{ width: "1000px" }}
        onHide={() => handleCancel()}
        focusOnShow={false}
      >
        <div className='diag-box'>
          <div className='grid'>
            <div className='col-12 p-0 diag-syndication'>Weather</div>
            <div className='col-12 pl-0'>
              <InputTextarea
                className='widthFull'
                required
                rows={20}
                value={temp}
                onChange={(event) => setTemp(event.target.value)}
              />
            </div>
            <div className='col-12 flex flex-row-reverse'>
              <Button
                label='Cancel'
                className='p-button ml-2 p-button-sm diag-discard-button'
                onClick={() => handleCancel()}
              />
              <Button
                label='Save'
                onClick={() => handleSave(section)}
                className='p-button ml-2 p-button-sm diag-save-button'
              />
              {(props.businessUnit === BUSINESS_UNIT.COCOA &&
                (props.region === REGIONS.SA_PG || props.region === REGIONS.SA_ES)) ||
                props.regions.map((reg) => {
                  if (reg.value !== props.region) {
                    return (
                      <Button
                        key={reg.value}
                        label={"Copy from " + reg.value}
                        onClick={() => {
                          setEditContent(false);
                          props.getContentBasedonDateAndRegion(
                            reg.value,
                            "Weather",
                            "current",
                            section,
                            props.getSectionData
                          );
                        }}
                        className='p-button ml-2 p-button-sm diag-save-button'
                      ></Button>
                    );
                  }
                  return <React.Fragment key={reg.value}></React.Fragment>;
                })}
              {/* { props.region!=="NA" &&
               <Button
                  label="Copy from NA"
                  onClick={() => {
                    setEditContent(false);
                    props.getContentBasedonDateAndRegion('NA', 'Previous Session','current', section, props.getSectionData)
                  }}
                  className="p-button ml-2 p-button-sm diag-save-button"
                />
              }
              { props.region!=="EMEA" &&
               <Button
                  label="Copy from EMEA"
                  onClick={() => {
                    setEditContent(false);
                    props.getContentBasedonDateAndRegion('EMEA', 'Previous Session','current', section, props.getSectionData)
                  }}
                  className="p-button ml-2 p-button-sm diag-save-button"
                />
              }
              { props.region!=="SA" &&
               <Button
                  label="Copy from SA"
                  onClick={() => {
                    setEditContent(false);
                    props.getContentBasedonDateAndRegion('SA', 'Previous Session','current', section, props.getSectionData)
                  }}
                  className="p-button ml-2 p-button-sm diag-save-button"
                />
              } */}
              <Button
                label='Copy from Yesterday'
                onClick={() => {
                  setEditContent(false);
                  props.getContentBasedonDateAndRegion(
                    props.region,
                    "Weather",
                    "previous",
                    section,
                    props.getSectionData
                  );
                }}
                className='p-button ml-2 p-button-sm diag-save-button'
              />
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        header='Weather Validation'
        className='section__validation__dialog'
        baseZIndex={10001}
        visible={isSectionInValid}
        modal
        style={{ width: "350px" }}
        footer={
          <Button
            label='Okay'
            icon='pi pi-check'
            onClick={() => setIsSectionInValid(false)}
            className='p-button-text'
          />
        }
        onHide={() => setIsSectionInValid(false)}
      >
        <div className='flex flex-column' style={{ color: "#FFF" }}>
          <div className='flex align-items-center'>
            <i className='pi pi-exclamation-triangle mr-3' style={{ fontSize: "2rem" }} />
            <span>Please fill the section content</span>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default Weather;
